import React from 'react';
import { string, shape } from 'prop-types';
import { Video } from '@fiverr-private/orca';
import { getContext } from '@fiverr-private/fiverr_context';
import { ALLOCATIONS, EXPERIMENTS } from '../../../constants/experiments';
import { getSubtitles } from '../services/subtitle';
import { VIDEO_TYPE } from './constants';

const ModalBody = ({ video, sourceInfo }) => {
    const {
        id,
        src
    } = video;

    const sources = [{
        src,
        type: VIDEO_TYPE
    }];

    const subtitles = getSubtitles(id);

    const { abTests = {} } = getContext();
    const shouldShowSubtitle = abTests[EXPERIMENTS.VIDEO_SUBTITLE] === ALLOCATIONS.TEST_B;

    return (
        <Video width="100%"
            height="100%"
            controls
            autoPlay
            source={sources}
            subtitles={shouldShowSubtitle ? subtitles : []}
            sourceInfo={sourceInfo}/>
    );
};

ModalBody.propTypes = {
    video: shape({
        id: string,
        name: string,
        src: string
    }),
    sourceInfo: shape({
        videoName: string,
        mixpanel: shape({
            pageName: string
        }),
        bigQuery: shape({
            pageName: string
        })
    })
};

export default ModalBody;
